import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { logoutUser } from '../../containers/Auth/auth.action';
import { ACTIONS } from '../../actions/actionTypes';
import PushNotification from '../../utils/pushNotification';
import System from '../../utils/system';
import Spinner from '../components/spinner';
// import {newMessage} from '../InteractionViews/interactions';
import 'font-awesome/css/font-awesome.min.css';
import UserCityView from '../AuthViews/userCityView';
import { updateNotification } from '../../controllers/notifications';
import UserFinishedGameView from '../UserViews/finishedGameView';
import BottomNavigation from './bottomNavigation';

class Dashboard extends Component {
    constructor (props) {
        super(props);
        this.state = {
            user: null,
            reproved: {
                time: null,
                situation: false
            },
            date: null,
            interval: null,
            isReproved: false
        };
        this.renderBuilding = this.renderBuilding.bind(this);
    }

    componentDidMount () {
        this.props.getDashboard();
        this.setToken();
        PushNotification.onNotificationOpen((notification) => {
            // notification.interactionType <- comes as a parametrer from the api
            // need to change this
            // let interactionType = notification.interactionType;
            // this.props.callInteraction(newMessage({title: notification.body, content: notification.content, interactionType}));
            // let id = notification.id;
            // let item = {
            //     notification: {
            //         received: true
            //     }
            // };
            // updateNotification(id, item);
        }, (error) => {
            console.log(error);
        });
        this.setTimeout();
    }

    setToken () {
        let notificationToken = window.localStorage.getItem('NOTIFICATION_TOKEN');
        if (notificationToken === null) {
            let {user} = this.props;
            if (user.notification) {
                PushNotification.getPermission((onSuccess) => {
                    PushNotification.getToken((pushNotificationToken) => {
                        if (!System.platform.cordova) {
                            user.notification.web.token.push(pushNotificationToken);
                        } else if (System.platform.OS === 'ANDROID') {
                            user.notification.android.token.push(pushNotificationToken);
                        } else if (System.platform.OS === 'IOS') {
                            user.notification.ios.token.push(pushNotificationToken);
                        }
                        this.props.updateUser(user);
                        window.localStorage.setItem('NOTIFICATION_TOKEN', pushNotificationToken);
                    }, (error) => {
                        console.log(error);
                    });
                }, (onFail) => {
                    window.localStorage.setItem('NOTIFICATION_TOKEN', 'denied');
                    if (!System.platform.cordova) {
                        user.notification.web.denied = true;
                    } else if (System.platform.OS === 'ANDROID') {
                        user.notification.android.denied = true;
                    } else if (System.platform.OS === 'IOS') {
                        user.notification.ios.denied = true;
                    }
                    console.log('onFail', onFail);
                });
            }
        }
    }

    setTimeout () {
        let reproved = JSON.parse(window.localStorage.getItem('reproved'));
        if (reproved !== null) {
            const interval = setInterval(() => {
                let date = new Date(this.state.reproved.time);
                date = new Date(date - Date.now());
                if (date <= 0) {
                    clearInterval(this.state.interval);
                    window.localStorage.setItem('reproved', null);
                    this.setState({interval: null, reproved: null, isReproved: false});
                } else {
                    this.setState({date: date});
                }
            }, 1000);
            let date = new Date(reproved.time);
            date = new Date(date - Date.now());
            this.setState({interval: interval, reproved: reproved, isReproved: true, date: date});
        }
    }

    openCuriosity (item) {
        this.props.push('./curiosities');
        this.props.setCuriosity(item);
    }

    reprovedStudent () {
        return (this.state.isReproved
            ? <div className='reproved'>
                Você foi reprovado, espere um pouco antes de continuar
                {this.renderBarTime(this.state.date, 300)}

            </div>
            : null);
    }

    renderBuilding (missions, areaNameAndImage) {
        let missionsInThisArea = [];
        let mission = null;
        if (missions) {
            missions = missions.slice(0, 3);
            missionsInThisArea = missions.filter(mission => {
                return mission.area.title === areaNameAndImage.title;
            });
        }

        if (missionsInThisArea.length) {
            mission = missionsInThisArea[0];
        }

        return (
            <div key={areaNameAndImage.title} className={'buildingWrapper ' + areaNameAndImage.class}>
                {(mission) ? this.renderPin(mission, areaNameAndImage.image) : null}
                <img src={require('../../images/predio-ufjf.png')} />
            </div>
        );
    }

    renderPin (mission, imageName) {
        return (
            <img src={require('../../images/' + imageName)}
                 onClick={() => {
                     if (!this.state.isReproved) {
                         mission.curiosity
                             ? this.openCuriosity(mission)
                             : this.props.proposeSession(mission);
                     }
                 }}
            />
        );
    }

    renderBarTime (time, maxTime) {
        let min = time.getMinutes();
        let sec = time.getSeconds();
        const percentage = (min * 60 + sec) / (maxTime);
        sec = (sec >= 10) ? sec : '0' + sec;
        return (
            <div className='dashboard-progress'>
                <div
                    className='progress-bar'
                    style={{
                        width: `${(1 - percentage) * 100 || 0}%`,
                        backgroundColor: '#FC775A'
                    }}>
                    <span className='progress-label'>{min + ':' + sec}</span>
                </div>
            </div>
        );
    }

    logout () {
        this.props.logoutUser();
    }

    render () {
        const areaNamesAndImages = [
            {
                title: 'Ciências Sociais Aplicadas',
                image: 'pin-sociais-aplicadas.png',
                class: 'cienciasSociais'
            },
            {
                title: 'Engenharias',
                image: 'pin-engenharias.png',
                class: 'engenharias'
            },
            {
                title: 'Ciências Humanas',
                image: 'pin-humnas.png',
                class: 'humanas'
            },
            {
                title: 'Linguística, Letras e Artes',
                image: 'pin-letras-artes.png',
                class: 'letras'
            },
            {
                title: 'Ciências Biológicas',
                image: 'pin-biologicas.png',
                class: 'biologicas'
            },
            {
                title: 'Ciências Exatas e da Terra',
                image: 'pin-exatas-terra.png',
                class: 'exatas'
            },
            {
                title: 'Ciências da Saúde',
                image: 'pin-saude.png',
                class: 'saude'
            }
        ];

        const user = this.props.user.data;
        if (user.level && ((!user.city && user.school === undefined && !user.otherCity) ||
                (!user.gender || user.gender === undefined))) {
            return (
                <UserCityView />
            );
        } else {
            if (user.level && user.level.title === 'Enem') {
                this.props.push('/enem');
                return (
                    <Spinner />
                );
            } else if (user.finishedGame === true) {
                return (
                    <UserFinishedGameView />
                );
            } else {
                return (
                    <div className='dashboard-background'>
                        <div className='mapWrapper'>
                            <div className='innerMapWrapper'>
                                <div className='map'>
                                    {areaNamesAndImages.map(nameAndImage => {
                                        return this.renderBuilding(this.props.missions, nameAndImage);
                                    })}
                                    {this.reprovedStudent()}
                                </div>
                            </div>
                        </div>
                        <BottomNavigation />
                    </div>
                );
            }
        }
    }
}

const mapStateToProps = (state) => ({
    user: state.user.user,
    platform: state.appState.platform,
    missions: state.missionReducer.missions
});

const mapDispatchToProps = (dispatch) => ({
    callInteraction: (item) => dispatch({
        type: ACTIONS.DISPATCH_INTERACTION,
        payload: item
    }),
    proposeSession: (mission) => dispatch({
        type: ACTIONS.PROPOSE_SESSION,
        payload: mission
    }),
    setCuriosity: (curiosity) => {
        dispatch({
            type: ACTIONS.SET_CURIOSITY,
            payload: curiosity
        });
    },
    acceptSession: () => dispatch({
        type: ACTIONS.ACCEPT_SESSION
    }),
    updateUser: (user) => dispatch({type: ACTIONS.USER_UPDATE_REMOTE_DATA, payload: user}),
    getDashboard: () => dispatch({type: ACTIONS.GET_DASHBOARD}),
    push: (location) => dispatch(push(location)),
    logoutUser: () => dispatch(logoutUser())
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/views/DashboardViews/dashBoardView.js